import { render } from "./unionBillModel.vue?vue&type=template&id=fd324b10"
import script from "./unionBillModel.vue?vue&type=script&lang=js"
export * from "./unionBillModel.vue?vue&type=script&lang=js"

import "./unionBillModel.vue?vue&type=style&index=0&id=fd324b10&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__